import { Users, MessageSquare } from "lucide-react";

type ViewMode = "contacts" | "threads";

interface QuickNavProps {
  activeView: ViewMode;
  onViewChange: (view: ViewMode) => void;
  unreadCount?: number;
  showContactsTab?: boolean; // Whether to show contacts tab
}

/**
 * Quick navigation tabs for mobile (inspired by Outlook's Focused/Other tabs)
 * Allows quick switching between contacts and threads
 */
export const QuickNav = ({
  activeView,
  onViewChange,
  unreadCount = 0,
  showContactsTab = true,
}: QuickNavProps) => {
  return (
    <div className="flex gap-1 p-1 bg-muted/30 rounded-lg mb-3">
      {showContactsTab && (
        <button
          type="button"
          onClick={() => onViewChange("contacts")}
          className={`flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-all ${
            activeView === "contacts"
              ? "bg-white text-primary shadow-sm dark:bg-white/10"
              : "text-muted-foreground hover:text-foreground"
          }`}
        >
          <Users className="h-4 w-4" />
          <span>Contacts</span>
        </button>
      )}
      <button
        type="button"
        onClick={() => onViewChange("threads")}
        className={`flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-all relative ${
          activeView === "threads"
            ? "bg-white text-primary shadow-sm dark:bg-white/10"
            : "text-muted-foreground hover:text-foreground"
        }`}
      >
        <MessageSquare className="h-4 w-4" />
        <span>Threads</span>
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-primary text-[10px] font-bold text-white flex items-center justify-center">
            {unreadCount > 9 ? "9+" : unreadCount}
          </span>
        )}
      </button>
    </div>
  );
};
